// extracted by mini-css-extract-plugin
module.exports = {"root":"ConnectIntegrationForm_root__Q5n6u","cases":"ConnectIntegrationForm_cases__C_8oR","form":"ConnectIntegrationForm_form__lLby1"};